/* TC Bundle — True Classic tarzı paket seçici.
   - Adet kartları (5'li / 3'lü / Tekli): gizli "quantity" alanıyla Dawn'ın sepete ekleme formuna gider.
   - Renk kombinleri: tek tıkla karışık renkli paket.
   - Kendi Paketin: sayfa içinde "Paketin | özelleştirmek için tıkla  0/N" kutuları; her kutuya renk seçilir.
   Karışık renkli paketler /cart/add.js ile tek seferde eklenir. Varyant seçimine dokunulmaz. */
(function () {
  if (window.__tcBundleInit) return;
  window.__tcBundleInit = true;

  const dataCache = new Map();

  function getData(sectionId) {
    if (dataCache.has(sectionId)) return dataCache.get(sectionId);
    const el = Array.from(document.querySelectorAll('script[data-tc-product-data]')).find(
      (s) => s.dataset.tcProductData === sectionId
    );
    if (!el) return null;
    try {
      const data = JSON.parse(el.textContent);
      dataCache.set(sectionId, data);
      return data;
    } catch (e) {
      return null;
    }
  }

  function formatMoney(cents, format) {
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    format = format || '{{amount}}';
    const fmt = (number, precision, thousands = ',', decimal = '.') => {
      if (number == null || isNaN(number)) return '0';
      const fixed = (number / 100).toFixed(precision);
      const parts = fixed.split('.');
      const whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    };
    const match = format.match(placeholder);
    if (!match) return format;
    let value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = fmt(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = fmt(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = fmt(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = fmt(cents, 2, "'", '.');
        break;
      case 'amount_with_space_separator':
        value = fmt(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = fmt(cents, 0, ' ', ',');
        break;
      default:
        value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  function esc(text) {
    const div = document.createElement('div');
    div.textContent = text == null ? '' : String(text);
    return div.innerHTML;
  }

  function norm(text) {
    return String(text || '').trim().toLocaleLowerCase('tr');
  }

  function cycle(list, length) {
    const out = [];
    if (!list || !list.length) return out;
    for (let i = 0; i < length; i++) out.push(list[i % list.length]);
    return out;
  }

  function resize(list, length) {
    const out = (list || []).slice(0, length);
    while (out.length < length) out.push(null);
    return out;
  }

  /* ---------- Durum ---------- */
  function state(pi) {
    if (!pi._tc) {
      const bundle = pi.querySelector('[data-tc-bundle]');
      pi._tc = { tier: bundle ? bundle.dataset.default : 'single', mode: null, combo: [], custom: [] };
    }
    return pi._tc;
  }

  function activeTier(pi) {
    const bundle = pi.querySelector('[data-tc-bundle]');
    if (!bundle) return null;
    const tiers = Array.from(bundle.querySelectorAll('[data-tc-tier]'));
    const st = state(pi);
    return tiers.find((t) => t.dataset.tcTier === st.tier) || tiers[0];
  }

  function currentQty(pi) {
    const tier = activeTier(pi);
    return tier ? parseInt(tier.dataset.qty, 10) || 1 : 1;
  }

  function currentDiscount(pi) {
    const tier = activeTier(pi);
    return tier ? parseFloat(tier.dataset.discount) || 0 : 0;
  }

  function selectedVariant(pi) {
    const el = pi.querySelector('variant-selects [data-selected-variant]');
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function findVariant(pi, colorName) {
    const data = getData(pi.dataset.section);
    const selected = selectedVariant(pi);
    if (!data || !selected || data.colorIndex < 0) return null;
    const ci = data.colorIndex;
    return (
      data.variants.find(
        (v) =>
          norm(v.options[ci]) === norm(colorName) &&
          v.options.every((opt, i) => i === ci || opt === selected.options[i])
      ) || null
    );
  }

  function customComplete(pi) {
    const st = state(pi);
    return st.custom.length === currentQty(pi) && st.custom.every(Boolean);
  }

  // Sepete gidecek renk listesi (karışık paket değilse null)
  function packColors(pi) {
    const st = state(pi);
    const qty = currentQty(pi);
    if (qty <= 1) return null;
    if (st.mode === 'combo') return cycle(st.combo, qty);
    if (st.mode === 'custom') return customComplete(pi) ? st.custom.slice() : null;
    return null;
  }

  /* ---------- Görünüm ---------- */
  function updateColorLabel(pi) {
    const label = pi.querySelector('.tc-opt--color [data-selected-value]');
    if (!label) return;
    if (label.dataset.tcOrig == null) label.dataset.tcOrig = label.textContent;
    const st = state(pi);
    const qty = currentQty(pi);
    const data = getData(pi.dataset.section) || {};
    let colors = null;
    if (qty > 1 && st.mode === 'combo') colors = cycle(st.combo, qty);
    if (qty > 1 && st.mode === 'custom') colors = st.custom.filter(Boolean);
    if (!colors) {
      label.textContent = label.dataset.tcOrig;
      return;
    }
    if (!colors.length) {
      const tpl = pi.querySelector('template[data-tc-custom-label]');
      label.textContent = tpl ? tpl.innerHTML.trim() : '';
      return;
    }
    const unique = [...new Set(colors)];
    label.textContent =
      unique.length > 2 ? `${unique.slice(0, 2).join(', ')} +${unique.length - 2} ${data.more || 'Daha'}` : unique.join(', ');
  }

  function updatePrice(pi) {
    const box = pi.querySelector('.tc-price[data-tc-price]');
    const data = getData(pi.dataset.section);
    if (!box || !data) return;
    if (box._tcOrig == null) box._tcOrig = box.innerHTML;
    const qty = currentQty(pi);
    const disc = currentDiscount(pi);
    if (qty <= 1 && disc === 0) {
      box.innerHTML = box._tcOrig;
      box.classList.remove('tc-price--bundle');
      return;
    }
    const price = parseInt(box.dataset.tcPrice, 10) || 0;
    const compare = parseInt(box.dataset.tcCompare, 10) || 0;
    const per = Math.round((price * (100 - disc)) / 100);
    const total = per * qty;
    const full = Math.max(compare, price) * qty;
    const money = (c) => formatMoney(c, data.moneyFormat);
    box.classList.add('tc-price--bundle');
    box.innerHTML =
      `<div class="tc-price__main"><span class="tc-price__per">${money(per)}</span>` +
      `<span class="tc-price__per-label">${esc(data.perItem)}</span></div>` +
      `<div class="tc-price__side">` +
      (full > total ? `<s class="tc-price__compare">${money(full)}</s>` : '') +
      `<span class="tc-price__total">${money(total)}</span></div>`;
  }

  function renderSlots(pi) {
    const wrap = pi.querySelector('[data-tc-slots]');
    if (!wrap) return;
    const st = state(pi);
    const qty = currentQty(pi);
    st.custom = resize(st.custom, qty);
    const grid = wrap.querySelector('[data-tc-slots-grid]');
    const filled = st.custom.filter(Boolean).length;
    wrap.querySelector('[data-tc-slots-count]').textContent = `${filled} / ${qty}`;
    let html = '';
    st.custom.forEach((name, i) => {
      if (name) {
        const variant = findVariant(pi, name);
        const soldOut = !variant || !variant.available;
        html +=
          `<div class="tc-bundle-slot is-filled${soldOut ? ' is-soldout' : ''}">` +
          `<button type="button" class="tc-bundle-slot__pick" data-tc-slot="${i}" aria-label="${esc(name)}">` +
          (variant && variant.image ? `<img src="${esc(variant.image)}" alt="" loading="lazy">` : '<span class="tc-bundle-slot__noimg"></span>') +
          `<span class="tc-bundle-slot__name">${esc(name)}</span></button>` +
          `<button type="button" class="tc-bundle-slot__remove" data-tc-slot-remove="${i}" aria-label="Kaldır">×</button>` +
          `</div>`;
      } else {
        html +=
          `<div class="tc-bundle-slot"><button type="button" class="tc-bundle-slot__pick" data-tc-slot="${i}" aria-label="${i + 1}">` +
          `<span class="tc-bundle-slot__plus" aria-hidden="true">+</span></button></div>`;
      }
    });
    grid.innerHTML = html;
  }

  function updateButton(pi) {
    const submit = pi.querySelector('product-form [type="submit"]');
    if (!submit) return;
    const label = submit.querySelector('span');
    if (!label) return;
    const st = state(pi);
    const qty = currentQty(pi);
    const incomplete = qty > 1 && st.mode === 'custom' && !customComplete(pi);
    if (incomplete) {
      if (label.dataset.tcOrig == null) label.dataset.tcOrig = label.textContent;
      const remaining = st.custom.filter((c) => !c).length;
      const tpl = pi.querySelector('template[data-tc-remaining]');
      const text = (tpl ? tpl.innerHTML.trim() : '[sayi] renk daha seç').replace('[sayi]', remaining);
      label.textContent = text;
      submit.classList.add('tc-needs-colors');
    } else if (label.dataset.tcOrig != null) {
      label.textContent = label.dataset.tcOrig;
      delete label.dataset.tcOrig;
      submit.classList.remove('tc-needs-colors');
    }
  }

  function updateMore(pi) {
    pi.querySelectorAll('[data-tc-more]').forEach((btn) => {
      const row = btn.parentElement;
      const overflow = row.scrollWidth - row.clientWidth > 8;
      btn.hidden = !overflow;
    });
  }

  function apply(pi) {
    const bundle = pi.querySelector('[data-tc-bundle]');
    if (!bundle) return;
    const st = state(pi);
    const active = activeTier(pi);
    bundle.querySelectorAll('[data-tc-tier]').forEach((t) => {
      const on = t === active;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    const qty = currentQty(pi);
    if (qty <= 1) st.mode = null;
    const qtyLabel = bundle.querySelector('[data-tc-bundle-qty]');
    if (qtyLabel) qtyLabel.textContent = qty;
    const input = bundle.querySelector('[data-tc-bundle-input]');
    if (input) input.value = qty;

    pi.classList.toggle('tc-pack', qty > 1);
    pi.classList.toggle('tc-mixed', qty > 1 && !!st.mode);
    pi.classList.toggle('tc-custom', qty > 1 && st.mode === 'custom');
    pi.querySelectorAll('[data-tc-combo]').forEach((c) => {
      const names = c.dataset.tcCombo.split(',').map((n) => n.trim());
      c.classList.toggle('is-active', st.mode === 'combo' && names.join('|') === st.combo.join('|'));
    });
    const custom = pi.querySelector('[data-tc-custom]');
    if (custom) custom.classList.toggle('is-active', st.mode === 'custom');

    renderSlots(pi);
    updateColorLabel(pi);
    updatePrice(pi);
    updateButton(pi);
    updateMore(pi);
    pi._tcBundleEl = bundle;
    pi._tcPriceEl = pi.querySelector('.tc-price[data-tc-price]');
  }

  /* ---------- Renk seçme penceresi ---------- */
  function chooserFor(pi) {
    return document.getElementById(`TcBuilder-${pi.dataset.section}`);
  }

  function renderChooser(modal) {
    const pi = modal._tcPi;
    const data = getData(pi.dataset.section) || {};
    const qty = currentQty(pi);
    modal.querySelector('[data-tc-builder-count]').textContent = `${modal._tcSlot + 1}. / ${qty}`;
    const current = state(pi).custom[modal._tcSlot];
    modal.querySelectorAll('[data-tc-builder-color]').forEach((btn) => {
      const variant = findVariant(pi, btn.dataset.tcBuilderColor);
      const ok = !!(variant && variant.available);
      btn.disabled = !ok;
      btn.classList.toggle('is-soldout', !ok);
      btn.classList.toggle('is-current', !!current && norm(current) === norm(btn.dataset.tcBuilderColor));
      btn.title = ok ? '' : data.soldOut || '';
    });
  }

  function openChooser(pi, slot, opener) {
    const modal = chooserFor(pi);
    if (!modal) return;
    modal._tcPi = pi;
    modal._tcSlot = slot;
    renderChooser(modal);
    if (!modal.hasAttribute('open') && typeof modal.show === 'function') modal.show(opener);
  }

  function enterCustom(pi, prefill) {
    const st = state(pi);
    if (currentQty(pi) <= 1) {
      const firstPack = pi.querySelector('[data-tc-tier]:not([data-tc-tier="single"])');
      if (firstPack) st.tier = firstPack.dataset.tcTier;
    }
    st.mode = 'custom';
    const qty = currentQty(pi);
    st.custom = prefill ? resize(cycle(prefill, qty), qty) : resize(st.custom, qty);
    apply(pi);
    const wrap = pi.querySelector('[data-tc-slots]');
    if (wrap && wrap.getBoundingClientRect().top > window.innerHeight - 80) {
      wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  /* ---------- Tıklamalar ---------- */
  document.addEventListener('click', (event) => {
    const tier = event.target.closest('[data-tc-tier]');
    if (tier) {
      const pi = tier.closest('product-info');
      if (!pi) return;
      const st = state(pi);
      st.tier = tier.dataset.tcTier;
      if ((parseInt(tier.dataset.qty, 10) || 1) <= 1) st.mode = null;
      apply(pi);
      return;
    }

    const edit = event.target.closest('[data-tc-edit]');
    if (edit) {
      event.preventDefault();
      const combo = edit.closest('[data-tc-combo]');
      const pi = edit.closest('product-info');
      if (pi && combo) enterCustom(pi, combo.dataset.tcCombo.split(',').map((n) => n.trim()).filter(Boolean));
      return;
    }

    const combo = event.target.closest('[data-tc-combo]');
    if (combo) {
      const pi = combo.closest('product-info');
      if (!pi) return;
      const st = state(pi);
      st.mode = 'combo';
      st.combo = combo.dataset.tcCombo.split(',').map((n) => n.trim()).filter(Boolean);
      apply(pi);
      return;
    }

    const custom = event.target.closest('[data-tc-custom]');
    if (custom) {
      const pi = custom.closest('product-info');
      if (pi) enterCustom(pi);
      return;
    }

    const more = event.target.closest('[data-tc-more]');
    if (more) {
      const row = more.parentElement;
      row.scrollBy({ left: row.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }

    const remove = event.target.closest('[data-tc-slot-remove]');
    if (remove) {
      const pi = remove.closest('product-info');
      if (!pi) return;
      state(pi).custom[parseInt(remove.dataset.tcSlotRemove, 10)] = null;
      apply(pi);
      return;
    }

    const slot = event.target.closest('[data-tc-slot]');
    if (slot) {
      const pi = slot.closest('product-info');
      if (pi) openChooser(pi, parseInt(slot.dataset.tcSlot, 10), slot);
      return;
    }

    const color = event.target.closest('[data-tc-builder-color]');
    if (color && !color.disabled) {
      const modal = color.closest('[data-tc-builder]');
      const pi = modal && modal._tcPi;
      if (!pi) return;
      const st = state(pi);
      st.custom[modal._tcSlot] = color.dataset.tcBuilderColor;
      apply(pi);
      const next = st.custom.findIndex((c, i) => !c && i > modal._tcSlot);
      const anyEmpty = next >= 0 ? next : st.custom.findIndex((c) => !c);
      if (anyEmpty >= 0) {
        modal._tcSlot = anyEmpty;
        renderChooser(modal);
      } else if (typeof modal.hide === 'function') {
        modal.hide();
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const combo = event.target.closest && event.target.closest('[data-tc-combo]');
    if (combo && event.target === combo) {
      event.preventDefault();
      combo.click();
    }
  });

  // Tek renk karosu seçilince karışık paket modundan çık
  document.addEventListener('change', (event) => {
    if (!event.target.closest('.tc-opt--color')) return;
    const pi = event.target.closest('product-info');
    if (pi && pi._tc) pi._tc.mode = null;
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('product-info').forEach((pi) => pi._tc && updateMore(pi));
  });

  /* ---------- Sepete ekle ---------- */
  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const productForm = form.closest('product-form');
      const pi = form.closest('product-info');
      if (!productForm || !pi || !pi._tc || !pi._tc.mode) return;
      const qty = currentQty(pi);
      if (qty <= 1) return;

      // Kendi paketin eksikse: ilk boş kutuyu aç
      if (pi._tc.mode === 'custom' && !customComplete(pi)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const empty = pi._tc.custom.findIndex((c) => !c);
        const slot = pi.querySelector(`[data-tc-slot="${empty}"]`);
        openChooser(pi, empty < 0 ? 0 : empty, slot);
        return;
      }

      const colors = packColors(pi);
      if (!colors) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const submit = productForm.querySelector('[type="submit"]');
      if (submit && submit.getAttribute('aria-disabled') === 'true') return;

      const missing = [];
      const grouped = new Map();
      colors.forEach((name) => {
        const variant = findVariant(pi, name);
        if (!variant || !variant.available) missing.push(name);
        else grouped.set(variant.id, (grouped.get(variant.id) || 0) + 1);
      });
      const data = getData(pi.dataset.section) || {};
      if (missing.length) {
        const msg = `${[...new Set(missing)].join(', ')}: ${data.soldOut || 'Tükendi'}`;
        if (typeof productForm.handleErrorMessage === 'function') productForm.handleErrorMessage(msg);
        else window.alert(msg);
        return;
      }

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = { items: [...grouped].map(([id, quantity]) => ({ id, quantity })) };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      if (typeof productForm.handleErrorMessage === 'function') productForm.handleErrorMessage();
      if (submit) {
        submit.setAttribute('aria-disabled', 'true');
        submit.classList.add('loading');
      }
      const spinner = productForm.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      try {
        const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body),
        });
        const result = await response.json();
        if (result.status) {
          if (typeof productForm.handleErrorMessage === 'function') {
            productForm.handleErrorMessage(result.description || result.message);
          }
          return;
        }
        if (!cart) {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        const first = (result.items && result.items[0]) || {};
        result.key = first.key;
        result.id = first.variant_id || first.id;
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: result.id, cartData: result });
        }
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(result);
      } catch (e) {
        console.error(e);
      } finally {
        if (submit) {
          submit.classList.remove('loading');
          submit.removeAttribute('aria-disabled');
        }
        if (spinner) spinner.classList.add('hidden');
      }
    },
    true
  );

  /* ---------- Başlatma ve yeniden çizimde durumu koru ---------- */
  function setup(pi) {
    if (!pi) return;
    if (pi._tcObserved) {
      apply(pi);
      return;
    }
    pi._tcObserved = true;
    apply(pi);
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      Promise.resolve().then(() => {
        queued = false;
        const bundle = pi.querySelector('[data-tc-bundle]');
        const price = pi.querySelector('.tc-price[data-tc-price]');
        if (bundle && (bundle !== pi._tcBundleEl || price !== pi._tcPriceEl)) apply(pi);
      });
    });
    observer.observe(pi, { childList: true, subtree: true });
  }

  function init(root = document) {
    root.querySelectorAll('product-info').forEach((pi) => {
      if (pi.querySelector('[data-tc-bundle]')) setup(pi);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  window.addEventListener('load', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
